import {
  type DefaultProcessStepSection,
  getSectionStartIndex,
} from "#modules/onboardingV2/domain/splitDefaultProcessSteps";

export const getReorderedDefaultProcessStepIndexes = <T extends { id: string; index: number }>(
  reorderedProcessSteps: T[],
  section: DefaultProcessStepSection,
) => {
  const startIndex = getSectionStartIndex(section);

  return reorderedProcessSteps.flatMap((processStep, position) => {
    const index = startIndex + position;

    return processStep.index === index ? [] : [{ id: processStep.id, index }];
  });
};
